export default __webpack_public_path__ + "static/media/imgLightEnQUALGO.f6670b68.png";